module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-694e96a9.png";